import { CONFIG } from "../../config/app.config";
import { subYears } from "../../utils/date-fns.utils";
var NOW = new Date();
export var CONTACT_AGE_RANGE_MIN = subYears(NOW, CONFIG.CONTACT_AGE_RANGE.MIN);
export var CONTACT_AGE_RANGE_MAX = subYears(NOW, CONFIG.CONTACT_AGE_RANGE.MAX);
